import React from 'react'
import PropTypes from 'prop-types'

import styles from './style.module.scss'

import MyImage from '@shared/components/myImage'
import TeamImage from '@assets/images/placeholder/team-placeholder.svg'
import { S3_PREFIX, BLUR_DATA_URL_BASE64 } from '@shared-submodule/sm-constants'
import { useRouter } from 'next/router'

const TeamForm = ({ team, teamData }) => {
  const router = useRouter()

  const handleClick = (slug) => {
    if (slug) {
      router.push(`/${slug}`)
    }
  }

  return (
    <section className="mb-3 mb-md-4">
      {/* <h6>{"Team Form"}</h6> */}
      <h3 className="small-head">{'Team Form'}</h3>
      <div className={`${styles.teamForm} overflow-hidden`}>
        {
          team && team?.length > 0 && (
            <div className={`${styles.item} overflow-hidden`}>
              <div
                className={`${styles.head}`}>
                <div className={`${styles.teamHead} d-flex align-items-center`}>
                  <div className={`${styles.teamImg} me-2 me-md-3 rounded-circle overflow-hidden flex-shrink-0`}>
                    <MyImage src={teamData?.oImg?.sUrl ? `${S3_PREFIX}${teamData?.oImg?.sUrl}` : TeamImage} alt="user" blurDataURL={BLUR_DATA_URL_BASE64} placeholder="blur" layout="responsive" width="20" height="20" />
                  </div>
                  <p className={`${styles.teamName} mb-0 me-md-0`}>{teamData?.sTitle}</p>
                </div>
                <div className={`${styles.matchList} d-flex align-items-center ms-auto`}>
                  {
                    team?.map((match, index) => {
                      return (
                        <div
                          key={index}
                          className={`${styles.status} ${!match?.oWinner?._id ? '' : match?.oWinner?._id === teamData?._id ? styles.win : styles.loss} text-center rounded-circle flex-shrink-0 small-text`}
                        >
                          {!match?.oWinner?._id ? 'D' : match?.oWinner?._id === teamData?._id ? 'W' : 'L'}
                        </div>
                      )
                    })
                  }
                </div>
              </div>
              <div className={`${styles.content} mt-0`}>
                {
                  team?.map((match, index) => {
                    return (
                      <div key={index} className={`${styles.itemSm} d-flex align-items-center mx-3`} onClick={() => handleClick(match?.oSeo?.sSlug)}>
                        <div className={`${styles.team} me-1`}>
                          <p className="mb-0">{match?.oTeamScoreA?.oTeam?.sAbbr || match?.oTeamScoreA?.oTeam?.sTitle}</p>
                          <p className="mb-0 me-md-0">
                            <span className="mb-0 font-bold">{`${match?.oTeamScoreA?.sScores} `}</span>
                            {`(${match?.oTeamScoreA?.sOvers} ov)`}
                          </p>
                        </div>
                        <p className={`${styles.result} text-muted flex-grow-1 text-center mb-0`}>{match?.sResult || match?.sStatusNote}</p>
                        <div className={`${styles.team} ms-1 text-end`}>
                          <p className="mb-0 ms-1">{match?.oTeamScoreB?.oTeam?.sAbbr || match?.oTeamScoreB?.oTeam?.sTitle}</p>
                          <p className="mb-0 me-md-0">
                            <span className="mb-0 font-bold">{`${match?.oTeamScoreB?.sScores} `}</span>
                            {`(${match?.oTeamScoreB?.sOvers} ov)`}
                          </p>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          )
        }
      </div>
    </section>
  )
}

TeamForm.propTypes = {
  teamData: PropTypes.object,
  team: PropTypes.array
}

export default TeamForm
